import { useState } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router-dom'
import { toast } from 'react-toastify'
import { toastErrorLog } from '../../helpers/toastErrorLog'
import { Estrellas } from '../reutilizables/estrellas/Estrellas'
import * as calificarVendedorService from '../servicios/calificarVendedorService'
import BordePrincipal from '../ui/BordePrincipal'
import './Estrellas.css'

const CALIFICACION_MIN_LENGTH = 20

const Calificar = () => {
  const { idPedidoItem, idPublicacion, idVendedor } = useParams()
  const location = useLocation().pathname.split('/')[1]
  const esProducto = location === 'CalificarProducto'
  const titulo = esProducto
    ? 'Contanos qué te pareció el Producto'
    : ' ¿Cómo fue la atención del vendedor?'

  const navigate = useNavigate()
  const idUsuarioCalifica = parseInt(localStorage.getItem('idUsuario'))
  const idPedidoItemParsed = parseInt(idPedidoItem)
  const idPublicacionParsed = parseInt(idPublicacion)
  const idVendedorParsed = parseInt(idVendedor)

  const [formData, setFormData] = useState({
    idPedidoItem: idPedidoItemParsed,
    idUsuarioCalifica: idUsuarioCalifica,
    calificacionAlVendedor: 0,
    calificacionAlItem: 0,
    comentario: '',
    idUsuarioCalificado: idVendedorParsed,
    idItem: idPublicacionParsed
  })

  const onSubmit = async (e) => {
    try {
      e.preventDefault()
      const nuevaCalificacion = {
        idPedidoItem: formData.idPedidoItem,
        idUsuarioCalifica: formData.idUsuarioCalifica,
        calificacionAlVendedor: formData.calificacionAlVendedor,
        calificacionAlItem: formData.calificacionAlItem,
        comentario: formData.comentario,
        idUsuarioCalificado: formData.idUsuarioCalificado,
        idItem: formData.idItem
      }

      const calificacion = esProducto
        ? formData.calificacionAlItem
        : formData.calificacionAlVendedor

      if (calificacion === 0 || formData.comentario === '') {
        // eslint-disable-next-line no-alert
        alert(
          calificacion === 0
            ? 'Por favor, ingresá una puntuación para la calificación.'
            : 'Por favor, escribí una opinión para la calificación.'
        )
        return
      }

      if (formData.comentario.length < CALIFICACION_MIN_LENGTH) {
        toast.error('Por favor, ingresá al menos 20 caracteres')
        return
      }

      // Si pasó todas las validaciones
      const { data } = await calificarVendedorService.insertar(nuevaCalificacion)
      setFormData((prev) => ({
        ...prev,
        idCalificacion: data.idCalificacion
      }))
      navigate('/Pedidos')
    } catch (error) {
      const mensaje = `Ocurrió un error al grabar la calificación.`
      toastErrorLog(error, mensaje, 'calificacionVendedor')
    }
  }

  const handleStarClick = (estrella) => {
    const propiedad = esProducto ? 'calificacionAlItem' : 'calificacionAlVendedor'
    setFormData((prev) => ({
      ...prev,
      [propiedad]: estrella
    }))
  }

  const onChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value
    }))
  }

  const volver = () => {
    navigate('/Pedidos')
  }

  return (
    <div>
      <BordePrincipal titulo="Calificar Producto">
        <h4 className="text-center">{titulo}</h4>
        <div className="row">
          <div className="col-1"></div>
          <div className="col text-center ml-auto mr-auto mb-4">
            <form onSubmit={onSubmit}>
              <Estrellas
                calificacion={
                  esProducto
                    ? formData.calificacionAlItem
                    : formData.calificacionAlVendedor
                }
                handleStarClick={handleStarClick}
              />

              <label htmlFor="comentario">Incluí tu opinión.</label>
              <textarea
                onChange={onChange}
                className="text-area mt-3 mb-3"
                name="comentario"
                id="comentario"
                cols="30"
                rows="10"
              ></textarea>
              <div className="row">
                <div className="col-md-6 d-flex justify-content-end">
                  <button
                    className="btn btn-primary w-25 ml-5"
                    onClick={volver}
                    type="button"
                  >
                    Volver
                  </button>
                </div>
                <div className="col-md-6 d-flex justify-content-start">
                  <button type="submit" className="btn btn-enviar w-25 mr-5">
                    Enviá tu Opinión
                  </button>
                </div>
              </div>
            </form>
          </div>
          <div className="col-1"></div>
        </div>
      </BordePrincipal>
    </div>
  )
}

export default Calificar
